import React from "react";
import FormFields from "../../../../../../../../../../../components/common/FormFields";
import utils from "../../../../../../../../../../../utils";

const fields = ["name", "email", "trackingId"];

const SalesTeamForm = ({ partnerFromParent }) => {
  return <FormFields currentItem={partnerFromParent} fields={fields} />;
};

SalesTeamForm.defaultProps = {
  partnerFromParent: {
    name: "",
    email: "",
    trackingId: utils.getRandomString(8),
  },
};

export default SalesTeamForm;
